<template>
  <div class="firm_invoce_and_report">
    <v-dialog :value="show" persistent max-width="1200">
      <v-card class="pb-6">
        <v-card-title class="headline">
          <h3>Счета и Акты для {{ item.name }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="$emit('close')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="sortedItems"
            :items-per-page="99999999"
            class="elevation-1"
          >
            <template v-slot:item.invoce="{ item }">
              <div class="flex" @click="$emit('invoce', item)">
                <img
                  class="ico hover"
                  :src="xlsICO"
                  alt="invoce xlsx file download"
                />
                <span>Счет № {{ item.bill }}</span>
              </div>
            </template>
            <template v-slot:item.report="{ item }">
              <div class="flex" @click="$emit('report', item)">
                <img
                  class="ico hover"
                  :src="xlsICO"
                  alt="report xlsx file download"
                />
                <span>Акт № {{ item.bill }}</span>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import xlsICO from "@/assets/xls.svg";
export default {
  name: "firm_invoce_and_report",
  components: {},
  data: () => ({
    xlsICO,
    headers: [
      { text: "№", value: "bill" },
      { text: "Счет", value: "invoce" },
      { text: "Акт", value: "report" },
      { text: "От", value: "created_at" },
      { text: "Сумма", value: "orderInfo.price" },
    ],
  }),
  props: {
    show: { type: Boolean, required: true },
    item: { type: Object, required: true },
  },
  computed:{
    sortedItems(){
      const excell = Object.assign([],this.item.excell)
      return excell.sort((a,b)=>{
        const aDate = new Date(a.created_at)
        const bDate = new Date(b.created_at)
        if (aDate > bDate){
          return -1
        }
        if (aDate < bDate){
          return 1
        }
        return 0
      })
    }
  }
};
</script>
<style lang="sass" scoped>
.headline
  height: 70px
.ico
  height: 40px
.flex
  display: flex
  align-items: center
  column-gap: 10px
  &:hover
    cursor: pointer
    span
      text-decoration: underline
</style>
